//#region src/utils/init/styledLogs.ts
var e = (e) => `color: #697a8b; ${e?.isBold ? "font-weight: 800" : ""}`;
//#endregion
export { e as getConsoleStyle };

//# sourceMappingURL=styledLogs.js.map